<template lang="html">
  <b-container id="control-panel">
    <h1 v-translate="{countdown}">Control Panel <small>(Autorefresh in %{countdown}s)</small></h1>
    <b-row v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0">
      <b-col>
        <b-form-group>
          <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
          <b-form-select class="w-auto" v-model="filterWarehouse" :options="warehousesSelect" @input="setInterval">
            <template slot="first">
              <option :value="null" v-translate>None</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <b-card-title v-translate>Shippings WAITING</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingWaitingDetail @click.prevent="showingWaiting = shippingsWaitingDanger">> 90 min <b-badge variant="danger">{{shippingsWaitingDanger.length}}</b-badge></b-link></span>
              <span v-if="shippingsWaitingDanger.length === 1 && shippingsWaitingDanger[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsWaitingDanger[0].id } }" target="_blank">#{{shippingsWaitingDanger[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsWaitingDanger[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsWaitingDanger[0].created_by_id } }" target="_blank">#{{shippingsWaitingDanger[0].created_by_id}}</b-link> {{shippingsWaitingDanger[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsWaitingDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingWaitingDetail @click.prevent="showingWaiting = shippingsWaitingWarning">> 40 min <b-badge variant="warning">{{shippingsWaitingWarning.length}}</b-badge></b-link></span>
              <span v-if="shippingsWaitingWarning.length === 1 && shippingsWaitingWarning[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsWaitingWarning[0].id } }" target="_blank">#{{shippingsWaitingWarning[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsWaitingWarning[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsWaitingWarning[0].created_by_id } }" target="_blank">#{{shippingsWaitingWarning[0].created_by_id}}</b-link> {{shippingsWaitingWarning[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsWaitingWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingWaitingDetail @click.prevent="showingWaiting = shippingsWaitingSuccess">&lt; 40 min <b-badge variant="success">{{shippingsWaitingSuccess.length}}</b-badge></b-link></span>
              <span v-if="shippingsWaitingSuccess.length === 1 && shippingsWaitingSuccess[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsWaitingSuccess[0].id } }" target="_blank">#{{shippingsWaitingSuccess[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsWaitingSuccess[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsWaitingSuccess[0].created_by_id } }" target="_blank">#{{shippingsWaitingSuccess[0].created_by_id}}</b-link> {{shippingsWaitingSuccess[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsWaitingSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3">
                <b-link v-b-modal.modalShippingWaitingDetail @click.prevent="showingWaiting = shippingsWaitingScheduled">
                  <translate>Future</translate>
                  <b-badge variant="dark">{{shippingsWaitingScheduled.length}}</b-badge>
                </b-link>
              </span>
            </b-row>
            <hr>
            <h4 v-translate>90 minutes</h4>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingWaitingDetail @click.prevent="showingWaiting = shippingsMinutes90Danger">> 30 min <b-badge variant="danger">{{shippingsMinutes90Danger.length}}</b-badge></b-link></span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingWaitingDetail @click.prevent="showingWaiting = shippingsMinutes90Success">&lt; 30 min <b-badge variant="success">{{shippingsMinutes90Success.length}}</b-badge></b-link></span>
            </b-row>
            <b-row>
              <span class="h4 ml-3">
                <b-link v-b-modal.modalShippingWaitingDetail @click.prevent="showingWaiting = shippingsMinutes90Scheduled">
                  <translate>Future</translate>
                  <b-badge variant="dark">{{shippingsMinutes90Scheduled.length}}</b-badge>
                </b-link>
              </span>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <b-card-title v-translate>Tours WAITING</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingWaitingDetail @click.prevent="showingWaiting = toursWaitingDanger">> 90 min <b-badge variant="danger">{{toursWaitingDanger.length}}</b-badge></b-link></span>
              <span v-if="toursWaitingDanger.length === 1 && toursWaitingDanger[0].type === 'tour'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewTour', params: { id: toursWaitingDanger[0].id } }" target="_blank">{{toursWaitingDanger[0].tour_label || '#' + $options.filters.uuid(toursWaitingDanger[0].id)}}</b-link>
                &raquo;
                {{toursWaitingDanger[0].count}} shippings
                <span v-if="toursWaitingDanger[0].courier_id">&raquo;
                  <b-link :to="{ name: 'viewUser', params: { id: toursWaitingDanger[0].courier_id } }" target="_blank">{{toursWaitingDanger[0].courier.name}}</b-link> <a v-if="toursWaitingDanger[0].courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(toursWaitingDanger[0].courier.phone)">WhatsApp</a>
                </span>
                &raquo;
                {{elapsedTime(toursWaitingDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingWaitingDetail @click.prevent="showingWaiting = toursWaitingWarning">> 40 min <b-badge variant="warning">{{toursWaitingWarning.length}}</b-badge></b-link></span>
              <span v-if="toursWaitingWarning.length === 1 && toursWaitingWarning[0].type === 'tour'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewTour', params: { id: toursWaitingWarning[0].id } }" target="_blank">{{toursWaitingWarning[0].tour_label || '#' + $options.filters.uuid(toursWaitingWarning[0].id)}}</b-link>
                &raquo;
                {{toursWaitingWarning[0].count}} shippings
                <span v-if="toursWaitingWarning[0].courier_id">&raquo;
                  <b-link :to="{ name: 'viewUser', params: { id: toursWaitingWarning[0].courier_id } }" target="_blank">{{toursWaitingWarning[0].courier.name}}</b-link> <a v-if="toursWaitingWarning[0].courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(toursWaitingWarning[0].courier.phone)">WhatsApp</a>
                </span>
                &raquo;
                {{elapsedTime(toursWaitingWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingWaitingDetail @click.prevent="showingWaiting = toursWaitingSuccess">&lt; 40 min <b-badge variant="success">{{toursWaitingSuccess.length}}</b-badge></b-link></span>
              <span v-if="toursWaitingSuccess.length === 1 && toursWaitingSuccess[0].type === 'tour'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewTour', params: { id: toursWaitingSuccess[0].id } }" target="_blank">{{toursWaitingSuccess[0].tour_label || '#' + $options.filters.uuid(toursWaitingSuccess[0].id)}}</b-link>
                &raquo;
                {{toursWaitingSuccess[0].count}} shippings
                <span v-if="toursWaitingSuccess[0].courier_id">&raquo;
                  <b-link :to="{ name: 'viewUser', params: { id: toursWaitingSuccess[0].courier_id } }" target="_blank">{{toursWaitingSuccess[0].courier.name}}</b-link> <a v-if="toursWaitingSuccess[0].courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(toursWaitingSuccess[0].courier.phone)">WhatsApp</a>
                </span>
                &raquo;
                {{elapsedTime(toursWaitingSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card>
          <b-card-title v-translate>Tours CONFIRMED</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingConfirmedDetail @click.prevent="showingConfirmed = toursConfirmedDanger">> 60 min <b-badge variant="danger">{{toursConfirmedDanger.length}}</b-badge></b-link></span>
              <span v-if="toursConfirmedDanger.length === 1 && toursConfirmedDanger[0].type === 'tour'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewTour', params: { id: toursConfirmedDanger[0].id } }" target="_blank">{{toursConfirmedDanger[0].tour_label || '#' + $options.filters.uuid(toursConfirmedDanger[0].id)}}</b-link>
                &raquo;
                {{toursConfirmedDanger[0].count}} shippings
                <span v-if="toursConfirmedDanger[0].courier_id">&raquo;
                  <b-link :to="{ name: 'viewUser', params: { id: toursConfirmedDanger[0].courier_id } }" target="_blank">{{toursConfirmedDanger[0].courier.name}}</b-link> <a v-if="toursConfirmedDanger[0].courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(toursConfirmedDanger[0].courier.phone)">WhatsApp</a>
                </span>
                &raquo;
                {{elapsedTime(toursConfirmedDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingConfirmedDetail @click.prevent="showingConfirmed = toursConfirmedWarning">> 30 min <b-badge variant="warning">{{toursConfirmedWarning.length}}</b-badge></b-link></span>
              <span v-if="toursConfirmedWarning.length === 1 && toursConfirmedWarning[0].type === 'tour'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewTour', params: { id: toursConfirmedWarning[0].id } }" target="_blank">{{toursConfirmedWarning[0].tour_label || '#' + $options.filters.uuid(toursConfirmedWarning[0].id)}}</b-link>
                &raquo;
                {{toursConfirmedWarning[0].count}} shippings
                <span v-if="toursConfirmedWarning[0].courier_id">&raquo;
                  <b-link :to="{ name: 'viewUser', params: { id: toursConfirmedWarning[0].courier_id } }" target="_blank">{{toursConfirmedWarning[0].courier.name}}</b-link> <a v-if="toursConfirmedWarning[0].courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(toursConfirmedWarning[0].courier.phone)">WhatsApp</a>
                </span>
                &raquo;
                {{elapsedTime(toursConfirmedWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingConfirmedDetail @click.prevent="showingConfirmed = toursConfirmedSuccess">&lt; 30 min <b-badge variant="success">{{toursConfirmedSuccess.length}}</b-badge></b-link></span>
              <span v-if="toursConfirmedSuccess.length === 1 && toursConfirmedSuccess[0].type === 'tour'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewTour', params: { id: toursConfirmedSuccess[0].id } }" target="_blank">{{toursConfirmedSuccess[0].tour_label || '#' + $options.filters.uuid(toursConfirmedSuccess[0].id)}}</b-link>
                &raquo;
                {{toursConfirmedSuccess[0].count}} shippings
                <span v-if="toursConfirmedSuccess[0].courier_id">&raquo;
                  <b-link :to="{ name: 'viewUser', params: { id: toursConfirmedSuccess[0].courier_id } }" target="_blank">{{toursConfirmedSuccess[0].courier.name}}</b-link> <a v-if="toursConfirmedSuccess[0].courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(toursConfirmedSuccess[0].courier.phone)">WhatsApp</a>
                </span>
                &raquo;
                {{elapsedTime(toursConfirmedSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <b-card-title v-translate>Shippings CONFIRMED</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingConfirmedDetail @click.prevent="showingConfirmed = shippingsConfirmedDanger">> 60 min <b-badge variant="danger">{{shippingsConfirmedDanger.length}}</b-badge></b-link></span>
              <span v-if="shippingsConfirmedDanger.length === 1 && shippingsConfirmedDanger[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsConfirmedDanger[0].id } }" target="_blank">#{{shippingsConfirmedDanger[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsConfirmedDanger[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsConfirmedDanger[0].created_by_id } }" target="_blank">#{{shippingsConfirmedDanger[0].created_by_id}}</b-link> {{shippingsConfirmedDanger[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsConfirmedDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingConfirmedDetail @click.prevent="showingConfirmed = shippingsConfirmedWarning">> 30 min <b-badge variant="warning">{{shippingsConfirmedWarning.length}}</b-badge></b-link></span>
              <span v-if="shippingsConfirmedWarning.length === 1 && shippingsConfirmedWarning[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsConfirmedWarning[0].id } }" target="_blank">#{{shippingsConfirmedWarning[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsConfirmedWarning[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsConfirmedWarning[0].created_by_id } }" target="_blank">#{{shippingsConfirmedWarning[0].created_by_id}}</b-link> {{shippingsConfirmedWarning[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsConfirmedWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingConfirmedDetail @click.prevent="showingConfirmed = shippingsConfirmedSuccess">&lt; 30 min <b-badge variant="success">{{shippingsConfirmedSuccess.length}}</b-badge></b-link></span>
              <span v-if="shippingsConfirmedSuccess.length === 1 && shippingsConfirmedSuccess[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsConfirmedSuccess[0].id } }" target="_blank">#{{shippingsConfirmedSuccess[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsConfirmedSuccess[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsConfirmedSuccess[0].created_by_id } }" target="_blank">#{{shippingsConfirmedSuccess[0].created_by_id}}</b-link> {{shippingsConfirmedSuccess[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsConfirmedSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
          </b-card-text>
        </b-card><b-card>
          <b-card-title v-translate>Shippings ATPICKUPPOINT</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingAtPickupPointDetail @click.prevent="showingAtPickupPoint = shippingsAtPickupPointDanger">> 60 min <b-badge variant="danger">{{shippingsAtPickupPointDanger.length}}</b-badge></b-link></span>
              <span v-if="shippingsAtPickupPointDanger.length === 1 && shippingsAtPickupPointDanger[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsAtPickupPointDanger[0].id } }" target="_blank">#{{shippingsAtPickupPointDanger[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsAtPickupPointDanger[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsAtPickupPointDanger[0].created_by_id } }" target="_blank">#{{shippingsAtPickupPointDanger[0].created_by_id}}</b-link> {{shippingsAtPickupPointDanger[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsAtPickupPointDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingAtPickupPointDetail @click.prevent="showingAtPickupPoint = shippingsAtPickupPointWarning">> 30 min <b-badge variant="warning">{{shippingsAtPickupPointWarning.length}}</b-badge></b-link></span>
              <span v-if="shippingsAtPickupPointWarning.length === 1 && shippingsAtPickupPointWarning[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsAtPickupPointWarning[0].id } }" target="_blank">#{{shippingsAtPickupPointWarning[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsAtPickupPointWarning[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsAtPickupPointWarning[0].created_by_id } }" target="_blank">#{{shippingsAtPickupPointWarning[0].created_by_id}}</b-link> {{shippingsAtPickupPointWarning[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsAtPickupPointWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingAtPickupPointDetail @click.prevent="showingAtPickupPoint = shippingsAtPickupPointSuccess">&lt; 30 min <b-badge variant="success">{{shippingsAtPickupPointSuccess.length}}</b-badge></b-link></span>
              <span v-if="shippingsAtPickupPointSuccess.length === 1 && shippingsAtPickupPointSuccess[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsAtPickupPointSuccess[0].id } }" target="_blank">#{{shippingsAtPickupPointSuccess[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsAtPickupPointSuccess[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsAtPickupPointSuccess[0].created_by_id } }" target="_blank">#{{shippingsAtPickupPointSuccess[0].created_by_id}}</b-link> {{shippingsAtPickupPointSuccess[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsAtPickupPointSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card>
          <b-card-title v-translate>On INCIDENCE</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalIncidencesDetail @click.prevent="showingConfirmed = shippingsConfirmedSuccess; showIncidencesId = 1">
                <translate>Taken by mistake</translate>
                <b-badge :variant="incidencesCount[1] === 0 ? 'success' : 'danger'">{{incidencesCount[1]}}</b-badge></b-link>
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalIncidencesDetail @click.prevent="showingConfirmed = shippingsConfirmedSuccess; showIncidencesId = 7">
                <translate>Wrong size</translate>
                <b-badge :variant="incidencesCount[7] === 0 ? 'success' : 'danger'">{{incidencesCount[7]}}</b-badge></b-link>
              </span>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <b-card-title v-translate>Shippings INTRANSIT</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingIntransitDetail @click.prevent="showingConfirmed = shippingsIntransitDanger">+48 hs <b-badge variant="danger">{{shippingsIntransitDanger.length}}</b-badge></b-link></span>
              <span v-if="shippingsIntransitDanger.length === 1 && shippingsIntransitDanger[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsIntransitDanger[0].id } }" target="_blank">#{{shippingsIntransitDanger[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsIntransitDanger[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsIntransitDanger[0].created_by_id } }" target="_blank">#{{shippingsIntransitDanger[0].created_by_id}}</b-link> {{shippingsIntransitDanger[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsIntransitDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingIntransitDetail @click.prevent="showingConfirmed = shippingsIntransitWarning">+24 hs <b-badge variant="danger">{{shippingsIntransitWarning.length}}</b-badge></b-link></span>
              <span v-if="shippingsIntransitWarning.length === 1 && shippingsIntransitWarning[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsIntransitWarning[0].id } }" target="_blank">#{{shippingsIntransitWarning[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsIntransitWarning[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsIntransitWarning[0].created_by_id } }" target="_blank">#{{shippingsIntransitWarning[0].created_by_id}}</b-link> {{shippingsIntransitWarning[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsIntransitWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingIntransitDetail @click.prevent="showingConfirmed = shippingsIntransitSuccess">+12 hs <b-badge variant="warning">{{shippingsIntransitSuccess.length}}</b-badge></b-link></span>
              <span v-if="shippingsIntransitSuccess.length === 1 && shippingsIntransitSuccess[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'viewShipping', params: { id: shippingsIntransitSuccess[0].id } }" target="_blank">#{{shippingsIntransitSuccess[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsIntransitSuccess[0].created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: shippingsIntransitSuccess[0].created_by_id } }" target="_blank">#{{shippingsIntransitSuccess[0].created_by_id}}</b-link> {{shippingsIntransitSuccess[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsIntransitSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card>
          <b-card-title v-translate>Idle Couriers</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalIdleCouriersDetail @click.prevent="showingIdleCouriers = idleCouriersDanger">> 90 min <b-badge variant="danger">{{idleCouriersDanger.length}}</b-badge></b-link></span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalIdleCouriersDetail @click.prevent="showingIdleCouriers = idleCouriersWarning">> 60 min <b-badge variant="warning">{{idleCouriersWarning.length}}</b-badge></b-link></span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalIdleCouriersDetail @click.prevent="showingIdleCouriers = idleCouriersSuccess">> 30 min <b-badge variant="success">{{idleCouriersSuccess.length}}</b-badge></b-link></span>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-modal id="modalShippingWaitingDetail" ref="modalShippingWaitingDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Shipping WAITING Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-card v-for="(item, index) in showingWaiting" :key="index">
        <b-row v-if="item.type === 'shipping'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'viewShipping', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col>
            <b-link :to="{ name: item.created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: item.created_by_id } }" target="_blank">#{{item.created_by_id}}</b-link> {{item.created_by_name}}
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
          <div style="position: absolute; top: 0; left: 0; padding: 0 5px; line-height: 1.2" class="bg-dark text-white" v-if="item.created_by_type === 'company'">
            <small v-translate>Company</small>
          </div>
        </b-row>
        <b-row v-if="item.type === 'tour'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'viewTour', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col>
            <span v-translate="{qty: item.count}">%{qty} shippings</span><br>
            <div v-if="item.tour_label">
              {{item.tour_label}}
            </div>
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
          <div style="position: absolute; top: 0; left: 0; padding: 0 5px; line-height: 1.2" class="bg-dark text-white" v-if="item.created_by_type === 'company'">
            <small v-translate>Company</small>
          </div>
        </b-row>
      </b-card>
      <h3 v-if="showingWaiting.length === 0" v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalShippingConfirmedDetail" ref="modalShippingConfirmedDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Shipping CONFIRMED Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-card v-for="(item, index) in showingConfirmed" :key="index">
        <b-row v-if="item.type === 'shipping'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'viewShipping', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col cols="3">
            <b-link :to="{ name: item.created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: item.created_by_id } }" target="_blank">#{{item.created_by_id}}</b-link> {{item.created_by_name}}
          </b-col>
          <b-col v-if="item.courier_id && item.courier">
            <b-link :to="{ name: 'viewUser', params: { id: item.courier_id } }" target="_blank">{{item.courier.name}}</b-link> <a v-if="item.courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(item.courier.phone)">WhatsApp</a>
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
          <div style="position: absolute; top: 0; left: 0; padding: 0 5px; line-height: 1.2" class="bg-dark text-white" v-if="item.created_by_type === 'company'">
            <small v-translate>Company</small>
          </div>
        </b-row>
        <b-row v-if="item.type === 'tour'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'viewTour', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col cols="2">
            <span v-translate="{qty: item.count}">%{qty} shippings</span><br>
            <div v-if="item.tour_label">
              {{item.tour_label}}
            </div>
          </b-col>
          <b-col v-if="item.courier_id && item.courier">
            <b-link :to="{ name: 'viewUser', params: { id: item.courier_id } }" target="_blank">{{item.courier.name}}</b-link> <a v-if="item.courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(item.courier.phone)">WhatsApp</a>
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
          <div style="position: absolute; top: 0; left: 0; padding: 0 5px; line-height: 1.2" class="bg-dark text-white" v-if="item.created_by_type === 'company'">
            <small v-translate>Company</small>
          </div>
        </b-row>
      </b-card>
      <h3 v-if="showingConfirmed.length === 0" v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalShippingAtPickupPointDetail" ref="modalShippingAtPickupPointDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Shipping ATPICKUPPOINT Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-card v-for="(item, index) in showingAtPickupPoint" :key="index">
        <b-row v-if="item.type === 'shipping'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'viewShipping', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col cols="3">
            <b-link :to="{ name: item.created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: item.created_by_id } }" target="_blank">#{{item.created_by_id}}</b-link> {{item.created_by_name}}
          </b-col>
          <b-col v-if="item.courier_id && item.courier">
            <b-link :to="{ name: 'viewUser', params: { id: item.courier_id } }" target="_blank">{{item.courier.name}}</b-link> <a v-if="item.courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(item.courier.phone)">WhatsApp</a>
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
          <div style="position: absolute; top: 0; left: 0; padding: 0 5px; line-height: 1.2" class="bg-dark text-white" v-if="item.created_by_type === 'company'">
            <small v-translate>Company</small>
          </div>
          <div style="position: absolute; top: 0; right: 0; padding: 0 5px; line-height: 1.2" class="bg-info text-white" v-if="item.tourId">
            <b-link :to="{ name: 'viewTour', params: { id: item.tourId } }" target="_blank" class="text-white"><small v-translate>In Tour</small></b-link>
          </div>
        </b-row>
      </b-card>
      <h3 v-if="showingAtPickupPoint.length === 0" v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalShippingIntransitDetail" ref="modalShippingIntransitDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Shipping INTRANSIT Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-card v-for="(item, index) in showingConfirmed" :key="index">
        <b-row v-if="item.type === 'shipping'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'viewShipping', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col cols="3">
            <b-link :to="{ name: item.created_by_type === 'company' ? 'viewCompany' : 'viewUser', params: { id: item.created_by_id } }" target="_blank">#{{item.created_by_id}}</b-link> {{item.created_by_name}}
          </b-col>
          <b-col v-if="item.courier_id && item.courier">
            <b-link :to="{ name: 'viewUser', params: { id: item.courier_id } }" target="_blank">{{item.courier.name}}</b-link> <a v-if="item.courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(item.courier.phone)">WhatsApp</a>
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
          <div style="position: absolute; top: 0; left: 0; padding: 0 5px; line-height: 1.2" class="bg-dark text-white" v-if="item.created_by_type === 'company'">
            <small v-translate>Company</small>
          </div>
          <div style="position: absolute; top: 0; right: 0; padding: 0 5px; line-height: 1.2" class="bg-info text-white" v-if="item.tourId">
            <b-link :to="{ name: 'viewTour', params: { id: item.tourId } }" target="_blank" class="text-white"><small v-translate>In Tour</small></b-link>
          </div>
        </b-row>
      </b-card>
      <h3 v-if="showingConfirmed.length === 0" v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalIncidencesDetail" ref="modalIncidencesDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Shippings on INCIDENCE Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <div v-if="incidencesCount[showIncidencesId] > 0">
        <b-card v-for="(item, index) in incidences[showIncidencesId]" :key="index">
          <b-row>
            <b-col cols="3">
              <b-link :to="{ name: 'viewShipping', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
            </b-col>
            <b-col cols="6" v-if="item.company_id">
              <b-link :to="{ name: 'viewCompany', params: { id: item.company_id } }" target="_blank">#{{item.company_id}}</b-link> {{item.company.name}}
            </b-col>
            <b-col cols="6" v-else>
              <b-link :to="{ name: 'viewUser', params: { id: item.user_id } }" target="_blank">#{{item.user_id}}</b-link> {{item.user.name}}
            </b-col>
            <b-col v-if="item.courier_id && item.courier">
              <b-link :to="{ name: 'viewUser', params: { id: item.courier_id } }" target="_blank">{{item.courier.name}}</b-link> <a v-if="item.courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(item.courier.phone)">WhatsApp</a>
            </b-col>
            <b-col cols="2">
              {{elapsedTime(item.status_history[0].created_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
            </b-col>
            <div style="position: absolute; top: 0; left: 0; padding: 0 5px; line-height: 1.2" class="bg-dark text-white" v-if="item.company_id">
              <small v-translate>Company</small>
            </div>
          </b-row>
        </b-card>
      </div>
      <h3 v-else v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalIdleCouriersDetail" ref="modalIdleCouriersDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>IDLE Couriers Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <div v-if="showingIdleCouriers.length > 0">
        <b-card v-for="(item, index) in showingIdleCouriers" :key="index">
          <b-row>
            <b-col>
              <user-card :user='item'  :vehicle-types-prop="vehicleTypes" />
            </b-col>
            <b-col cols="3">
              {{elapsedTime(item.last_shipping_status_date, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
            </b-col>
          </b-row>
        </b-card>
      </div>
      <h3 v-else v-translate>No data</h3>
    </b-modal>
  </b-container>
</template>

<script>
import UserCard from '@/components/UserCard'

export default {
  components: {
    UserCard
  },
  data() {
    return {
      waitings: {
        shippings: [],
        tours: []
      },
      minutes90: {
        shippings: [],
        tours: []
      },
      confirmeds: {
        shippings: [],
        tours: []
      },
      atPickupPoints: {
        shippings: [],
        tours: []
      },
      intransits: {
        shippings: [],
        tours: []
      },
      intervalData: null,
      intervalCountdown: null,
      countdown: 300,
      showingWaiting: [],
      showingConfirmed: [],
      showingAtPickupPoint: [],
      incidences: [],
      incidencesCount: [],
      idleCouriers: [],
      showingIdleCouriers: [],
      showIncidencesId: null,
      filterWarehouse: null
    }
  },
  computed: {
    shippingsWaitingDanger() {
      return this.waitings.shippings.filter(x => x.label === 'danger')
    },
    shippingsWaitingWarning() {
      return this.waitings.shippings.filter(x => x.label === 'warning')
    },
    shippingsWaitingSuccess() {
      return this.waitings.shippings.filter(x => x.label === 'success')
    },
    shippingsWaitingScheduled() {
      return this.waitings.shippings.filter(x => x.label === 'dark')
    },
    shippingsMinutes90Danger() {
      return this.minutes90.shippings.filter(x => x.label === 'danger')
    },
    shippingsMinutes90Success() {
      return this.minutes90.shippings.filter(x => x.label === 'success')
    },
    shippingsMinutes90Scheduled() {
      return this.minutes90.shippings.filter(x => x.label === 'dark')
    },
    toursWaitingDanger() {
      return this.waitings.tours.filter(x => x.label === 'danger')
    },
    toursWaitingWarning() {
      return this.waitings.tours.filter(x => x.label === 'warning')
    },
    toursWaitingSuccess() {
      return this.waitings.tours.filter(x => x.label === 'success')
    },
    toursMinutes90Danger() {
      return this.minutes90.tours.filter(x => x.label === 'danger')
    },
    toursMinutes90Success() {
      return this.minutes90.tours.filter(x => x.label === 'success')
    },
    shippingsConfirmedDanger() {
      return this.confirmeds.shippings.filter(x => x.label === 'danger')
    },
    shippingsConfirmedWarning() {
      return this.confirmeds.shippings.filter(x => x.label === 'warning')
    },
    shippingsConfirmedSuccess() {
      return this.confirmeds.shippings.filter(x => x.label === 'success')
    },
    toursConfirmedDanger() {
      return this.confirmeds.tours.filter(x => x.label === 'danger')
    },
    toursConfirmedWarning() {
      return this.confirmeds.tours.filter(x => x.label === 'warning')
    },
    toursConfirmedSuccess() {
      return this.confirmeds.tours.filter(x => x.label === 'success')
    },
    shippingsAtPickupPointDanger() {
      return this.atPickupPoints.shippings.filter(x => x.label === 'danger')
    },
    shippingsAtPickupPointWarning() {
      return this.atPickupPoints.shippings.filter(x => x.label === 'warning')
    },
    shippingsAtPickupPointSuccess() {
      return this.atPickupPoints.shippings.filter(x => x.label === 'success')
    },
    shippingsIntransitDanger() {
      return this.intransits.shippings.filter(x => x.label === 'danger')
    },
    shippingsIntransitWarning() {
      return this.intransits.shippings.filter(x => x.label === 'warning')
    },
    shippingsIntransitSuccess() {
      return this.intransits.shippings.filter(x => x.label === 'success')
    },
    idleCouriersDanger() {
      return this.idleCouriers.filter(x => x.idle >= 90)
    },
    idleCouriersWarning() {
      return this.idleCouriers.filter(x => x.idle >= 60 && x.idle < 90)
    },
    idleCouriersSuccess() {
      return this.idleCouriers.filter(x => x.idle < 60)
    }
  },
  created() {
    this.fetchWarehouses()
    this.fetchVehicleTypes()
    this.fetchShippingTypes()
      .then(r => {
        this.filterWarehouse = this.$cookies.get('warehouse') || null
        this.setInterval()
      })
  },
  mounted() {
  },
  beforeDestroy() {
    clearInterval(this.intervalData)
    clearInterval(this.intervalCountdown)
  },
  methods: {
    setInterval() {
      if (this.filterWarehouse) {
        this.$cookies.set('warehouse', this.filterWarehouse)
      } else {
        this.$cookies.remove('warehouse')
      }
      this.intervalData = setInterval(function () {
        this.reloadData()
      }.bind(this), 300000)
      this.reloadData()
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
    },
    reloadData() {
      this.getWaitings()
      this.fectchIncidences(1)
      this.fectchIncidences(7)
    },
    getWaitings() {
      let params = {
        includes: ['company', 'status_history', 'user', 'tour'],
        page: 0,
        limit: 500,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'WAITING'],
              ['courier_id', 'eq', 'null'],
              ['shipping_type_id', 'eq', this.shippingTypes.find(x => x.name === 'minutes_90').id, 'true']
            ]
          }
        ]
      }
      if (this.$store.getters.profile.meta) {
        let meta
        try {
          meta = JSON.parse(this.$store.getters.profile.meta)
        } catch (e) {
          meta = this.$store.getters.profile.meta
        }
        if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length === 0 && meta.backofficePreferences.companies.exclude.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.exclude.ids, true])
        } else if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.include.ids])
        }
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          Object.assign(this.$data.waitings, this.$options.data.call(this).waitings)
          this.countdown = 300
          this.setIntervalCountdown()
          for (let shipping of response.body.data) {
            if (shipping.tour_id && this.waitings.tours.findIndex(x => x.id === shipping.tour_id) === -1) {
              let tour = {
                id: shipping.tour_id,
                type: 'tour',
                tour_label: shipping.tour.label,
                updated_at: shipping.status_history.length > 0 && shipping.status_history[0].status === 'WAITING' ? shipping.status_history[0].created_at : shipping.updated_at,
                count: 1,
                status: shipping.status_history.length > 0 ? shipping.status_history[0].status : shipping.status
              }
              if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'WAITING' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(90, 'minutes')) {
                tour['label'] = 'danger'
              } else if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'WAITING' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(40, 'minutes')) {
                tour['label'] = 'warning'
              } else {
                tour['label'] = 'success'
              }
              this.waitings.tours.push(tour)
            } else if (shipping.tour_id && this.waitings.tours.findIndex(x => x.id === shipping.tour_id) !== -1) {
              this.waitings.tours[this.waitings.tours.findIndex(x => x.id === shipping.tour_id)].count++
            } else {
              let waiting = {
                id: shipping.id,
                type: 'shipping',
                updated_at: shipping.status_history.length > 0 && shipping.status_history[0].status === 'WAITING' ? shipping.status_history[0].created_at : shipping.updated_at,
                created_by_id: shipping.company ? shipping.company.id : shipping.user.id,
                created_by_name: shipping.company ? shipping.company.name : shipping.user.name,
                created_by_type: shipping.company ? 'company' : 'particular',
                status: shipping.status_history.length > 0 ? shipping.status_history[0].status : shipping.status
              }
              if (shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().utc()) {
                waiting['label'] = 'dark'
                waiting['updated_at'] = shipping.scheduled_date
              } else if (this.moment.utc(this.checkDateToUse(shipping)) < this.moment().utc().subtract(90, 'minutes')) {
                waiting['label'] = 'danger'
                if (shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().subtract(48, 'hours').utc()) {
                  waiting['updated_at'] = shipping.scheduled_date
                }
              } else if (this.moment.utc(this.checkDateToUse(shipping)) < this.moment().utc().subtract(40, 'minutes')) {
                waiting['label'] = 'warning'
                if (shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().subtract(48, 'hours').utc()) {
                  waiting['updated_at'] = shipping.scheduled_date
                }
              } else {
                waiting['label'] = 'success'
                if (shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().subtract(48, 'hours').utc()) {
                  waiting['updated_at'] = shipping.scheduled_date
                }
              }

              this.waitings.shippings.push(waiting)
            }
          }
          this.getMinutes90()
        })
    },
    getMinutes90() {
      let params = {
        includes: ['company', 'status_history', 'user', 'tour'],
        page: 0,
        limit: 500,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'WAITING'],
              ['courier_id', 'eq', 'null'],
              ['shipping_type_id', 'eq', this.shippingTypes.find(x => x.name === 'minutes_90').id]
            ]
          }
        ]
      }
      if (this.$store.getters.profile.meta) {
        let meta
        try {
          meta = JSON.parse(this.$store.getters.profile.meta)
        } catch (e) {
          meta = this.$store.getters.profile.meta
        }
        if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length === 0 && meta.backofficePreferences.companies.exclude.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.exclude.ids, true])
        } else if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.include.ids])
        }
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          Object.assign(this.$data.minutes90, this.$options.data.call(this).minutes90)
          for (let shipping of response.body.data) {
            if (shipping.tour_id && this.minutes90.tours.findIndex(x => x.id === shipping.tour_id) === -1) {
              let tour = {
                id: shipping.tour_id,
                type: 'tour',
                tour_label: shipping.tour.label,
                updated_at: shipping.status_history.length > 0 && shipping.status_history[0].status === 'WAITING' ? shipping.status_history[0].created_at : shipping.updated_at,
                count: 1,
                status: shipping.status_history.length > 0 ? shipping.status_history[0].status : shipping.status
              }
              if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'WAITING' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(30, 'minutes')) {
                tour['label'] = 'danger'
              } else {
                tour['label'] = 'success'
              }
              this.minutes90.tours.push(tour)
            } else if (shipping.tour_id && this.minutes90.tours.findIndex(x => x.id === shipping.tour_id) !== -1) {
              this.minutes90.tours[this.minutes90.tours.findIndex(x => x.id === shipping.tour_id)].count++
            } else {
              let waiting = {
                id: shipping.id,
                type: 'shipping',
                updated_at: shipping.status_history.length > 0 && shipping.status_history[0].status === 'WAITING' ? shipping.status_history[0].created_at : shipping.updated_at,
                created_by_id: shipping.company ? shipping.company.id : shipping.user.id,
                created_by_name: shipping.company ? shipping.company.name : shipping.user.name,
                created_by_type: shipping.company ? 'company' : 'particular',
                status: shipping.status_history.length > 0 ? shipping.status_history[0].status : shipping.status
              }
              if (shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().utc()) {
                waiting['label'] = 'dark'
                waiting['updated_at'] = shipping.scheduled_date
              } else if (this.moment.utc(this.checkDateToUse(shipping)) < this.moment().utc().subtract(30, 'minutes')) {
                waiting['label'] = 'danger'
                if (shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().subtract(48, 'hours').utc()) {
                  waiting['updated_at'] = shipping.scheduled_date
                }
              } else {
                waiting['label'] = 'success'
                if (shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().subtract(48, 'hours').utc()) {
                  waiting['updated_at'] = shipping.scheduled_date
                }
              }

              this.minutes90.shippings.push(waiting)
            }
          }
          this.getConfirmeds()
        })
    },
    checkDateToUse(shipping) {
      let checkedDate
      if (shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().subtract(48, 'hours').utc()) {
        checkedDate = shipping.scheduled_date
      } else {
        checkedDate = shipping.status_history.length > 0 && shipping.status_history[0].status === 'WAITING' ? shipping.status_history[0].created_at : shipping.updated_at
      }
      return checkedDate
    },
    getConfirmeds() {
      let params = {
        includes: ['company', 'status_history', 'user', 'courier', 'tour'],
        page: 0,
        limit: 500,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'CONFIRMED'],
              ['status_history.status', 'in', ['WAITING']]
            ]
          }
        ]
      }
      if (this.$store.getters.profile.meta) {
        let meta
        try {
          meta = JSON.parse(this.$store.getters.profile.meta)
        } catch (e) {
          meta = this.$store.getters.profile.meta
        }
        if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length === 0 && meta.backofficePreferences.companies.exclude.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.exclude.ids, true])
        } else if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.include.ids])
        }
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          Object.assign(this.$data.confirmeds, this.$options.data.call(this).confirmeds)
          for (let shipping of response.body.data) {
            if (shipping.tour_id && this.confirmeds.tours.findIndex(x => x.id === shipping.tour_id) === -1) {
              let tour = {
                id: shipping.tour_id,
                type: 'tour',
                tour_label: shipping.tour.label,
                updated_at: shipping.status_history.length > 0 && shipping.status_history[0].status === 'CONFIRMED' ? shipping.status_history[0].created_at : shipping.updated_at,
                count: 1,
                courier_id: shipping.courier_id,
                courier: shipping.courier,
                status: shipping.status_history.length > 0 ? shipping.status_history[0].status : shipping.status
              }
              if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'CONFIRMED' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(60, 'minutes')) {
                tour['label'] = 'danger'
              } else if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'CONFIRMED' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(30, 'minutes')) {
                tour['label'] = 'warning'
              } else {
                tour['label'] = 'success'
              }

              this.confirmeds.tours.push(tour)
            } else if (shipping.tour_id && this.confirmeds.tours.findIndex(x => x.id === shipping.tour_id) !== -1) {
              this.confirmeds.tours[this.confirmeds.tours.findIndex(x => x.id === shipping.tour_id)].count++
            } else {
              let waiting = {
                id: shipping.id,
                type: 'shipping',
                updated_at: shipping.status_history.length > 0 && shipping.status_history[0].status === 'CONFIRMED' ? shipping.status_history[0].created_at : shipping.updated_at,
                created_by_id: shipping.company ? shipping.company.id : shipping.user.id,
                created_by_name: shipping.company ? shipping.company.name : shipping.user.name,
                created_by_type: shipping.company ? 'company' : 'particular',
                courier_id: shipping.courier_id,
                courier: shipping.courier,
                status: shipping.status_history.length > 0 ? shipping.status_history[0].status : shipping.status
              }
              if (shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().utc()) {
                waiting['label'] = 'dark'
              } else if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'CONFIRMED' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(60, 'minutes')) {
                waiting['label'] = 'danger'
              } else if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'CONFIRMED' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(30, 'minutes')) {
                waiting['label'] = 'warning'
              } else {
                waiting['label'] = 'success'
              }

              this.confirmeds.shippings.push(waiting)
            }
          }
          this.getAtPickupPoints()
        })
    },
    getAtPickupPoints() {
      let params = {
        includes: ['company', 'status_history', 'user', 'courier', 'tour'],
        page: 0,
        limit: 500,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'ATPICKUPPOINT']
              // ['status_history.status', 'in', ['WAITING']]
            ]
          }
        ]
      }
      if (this.$store.getters.profile.meta) {
        let meta
        try {
          meta = JSON.parse(this.$store.getters.profile.meta)
        } catch (e) {
          meta = this.$store.getters.profile.meta
        }
        if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length === 0 && meta.backofficePreferences.companies.exclude.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.exclude.ids, true])
        } else if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.include.ids])
        }
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          Object.assign(this.$data.atPickupPoints, this.$options.data.call(this).atPickupPoints)
          for (let shipping of response.body.data) {
            let waiting = {
              id: shipping.id,
              type: 'shipping',
              updated_at: shipping.status_history.length > 0 && shipping.status_history[0].status === 'CONFIRMED' ? shipping.status_history[0].created_at : shipping.updated_at,
              created_by_id: shipping.company ? shipping.company.id : shipping.user.id,
              created_by_name: shipping.company ? shipping.company.name : shipping.user.name,
              created_by_type: shipping.company ? 'company' : 'particular',
              courier_id: shipping.courier_id,
              courier: shipping.courier,
              status: shipping.status_history.length > 0 ? shipping.status_history[0].status : shipping.status,
              tourId: shipping.tour_id || null
            }
            if (shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().utc()) {
              waiting['label'] = 'dark'
            } else if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'CONFIRMED' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(60, 'minutes')) {
              waiting['label'] = 'danger'
            } else if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'CONFIRMED' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(30, 'minutes')) {
              waiting['label'] = 'warning'
            } else {
              waiting['label'] = 'success'
            }

            this.atPickupPoints.shippings.push(waiting)
          }
          this.getIntransits()
        })
    },
    getIntransits() {
      let params = {
        includes: ['company', 'status_history', 'user', 'tour'],
        page: 0,
        limit: 500,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'INTRANSIT'],
              ['updated_at', 'lte', this.moment().utc().subtract(12, 'hour').format('YYYY-MM-DD HH:mm:ss')]
            ]
          }
        ]
      }
      if (this.$store.getters.profile.meta) {
        let meta
        try {
          meta = JSON.parse(this.$store.getters.profile.meta)
        } catch (e) {
          meta = this.$store.getters.profile.meta
        }
        if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length === 0 && meta.backofficePreferences.companies.exclude.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.exclude.ids, true])
        } else if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.include.ids])
        }
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          Object.assign(this.$data.intransits, this.$options.data.call(this).intransits)
          for (let shipping of response.body.data) {
            let intransit = {
              id: shipping.id,
              type: 'shipping',
              updated_at: shipping.status_history.length > 0 && shipping.status_history[0].status === 'INTRANSIT' ? shipping.status_history[0].created_at : shipping.updated_at,
              created_by_id: shipping.company ? shipping.company.id : shipping.user.id,
              created_by_name: shipping.company ? shipping.company.name : shipping.user.name,
              created_by_type: shipping.company ? 'company' : 'particular',
              courier_id: shipping.courier_id,
              courier: shipping.courier,
              status: shipping.status_history.length > 0 ? shipping.status_history[0].status : shipping.status,
              tourId: shipping.tour_id || null
            }
            if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'INTRANSIT' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(48, 'hours')) {
              intransit['label'] = 'danger'
            } else if (this.moment.utc(shipping.status_history.length > 0 && shipping.status_history[0].status === 'INTRANSIT' ? shipping.status_history[0].created_at : shipping.updated_at) < this.moment().utc().subtract(24, 'hours')) {
              intransit['label'] = 'warning'
            } else {
              intransit['label'] = 'success'
            }

            this.intransits.shippings.push(intransit)
          }
        })
      this.fetchIdles()
    },
    fectchIncidences(id) {
      let params = {
        incidence_type_id: id,
        includes: [
          'status_history',
          'user',
          'company'
        ],
        date_to: this.moment().format('YYYY-MM-DD'),
        date_from: this.moment().format('YYYY-MM-DD'),
        sort: [
          {
            key: 'incidence_count',
            direction: 'desc'
          },
          {
            key: 'updated_at',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'INCIDENCE']
            ]
          }
        ]
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.$store.getters.profile.meta) {
        let meta
        try {
          meta = JSON.parse(this.$store.getters.profile.meta)
        } catch (e) {
          meta = this.$store.getters.profile.meta
        }
        if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length === 0 && meta.backofficePreferences.companies.exclude.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.exclude.ids, true])
        } else if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length > 0) {
          params.filter_groups[0].filters.push(['company_id', 'in', meta.backofficePreferences.companies.include.ids])
        }
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/with-incidence?incidence_type_id=' + id + '&status=INCIDENCE&includes[]=status_history&includes[]=user&includes[]=company', {params: params})
        .then(response => {
          if (typeof this.incidencesCount !== 'undefined' && typeof this.incidencesCount[id] !== 'undefined') {
            this.incidencesCount[id] = []
          }
          if (typeof this.incidences !== 'undefined' && typeof this.incidences[id] !== 'undefined') {
            this.incidences[id] = []
          }

          this.$set(this.incidencesCount, id, response.body.pagination.total)
          this.$set(this.incidences, id, response.body.data)
        })
    },
    fetchIdles() {
      let params = {
        minutes: 30,
        filter_groups: []
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['country_iso_code', 'eq', window.country]
            ]
          }
        )
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'couriers-idle', {params: params})
        .then(response => {
          response.body.data.forEach((item, i) => {
            response.body.data[i].idle = (this.moment().utc() - this.moment.utc(item.last_shipping_status_date)) / 1000 / 60
          })
          this.idleCouriers = response.body.data.sort((a, b) => (a.idle < b.idle) ? 1 : -1)
        })
    }
  }
}
</script>
